import useAPIClient from "../../core/services/API/hooks/useAPIClient";
import useCacheQuery, {CacheQueryOpts, CacheQueryOutput} from "../../core/services/query/hooks/useCacheQuery";
import CityName from "../../cities/types/CityName";

type Output = CityName[];

export default function useCityListForActiveEventsGet(
    customerId: number,
    options?: CacheQueryOpts
): CacheQueryOutput<Output> {
    const client = useAPIClient();
    return useCacheQuery<Output>(
        ["event-cities-by-active-events", customerId],
        () => {
            return client.get<any>(`city_events`, {
                "customer": `${customerId}`,
                "itemsPerPage": 100,
                "order[eventStartDate]": 'ASC',
            });
        },
        options
    );
}